var React = require('react');

function PlayiconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 16.4521L11 9.45215L11 23.4521L24 16.4521Z","stroke":"#2250FF","key":0}),React.createElement("rect",{"x":"0.5","y":"0.952148","width":"31","height":"31","rx":"15.5","stroke":"#2250FF","key":1})]);
}

PlayiconInline.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = PlayiconInline;

PlayiconInline.default = PlayiconInline;
